<template>
    <v-ons-page id="menuPage">
        <v-ons-toolbar>
            <div class="left zindex9 icon-left">
                <v-ons-back-button material></v-ons-back-button>
            </div>
            <div :class="{'text-center minus7-ml':'!back' }" class="center zindex1">
              <slot> </slot>
            </div>
            <div class="right zindex9 icon-right" @click="pushMap()">
                <img :src="icon_map">
            </div>
        </v-ons-toolbar>
        <!--<div class="header">-->
        <!--<img src="../assets/onsenui-logo.png">-->
        <!--</div>-->

        <ons-list class="menulist">
            <ons-list-item class="padding0" tappable @click="push(item)" v-for="(item,index) in fullMenuItems"
                           :key="index">

                <!--<div class="left"></div>-->
                <div class="center">

                    <div class="content">
                        <img :src="require('../assets/img/art/'+item.img)" height="100%" width="100%"/>
                        <div class="title font22pt">{{item.title}}</div>

                        <div class="author font18pt">{{item.author}}</div>
                    </div>

                </div>
            </ons-list-item>
        </ons-list>
    </v-ons-page>
</template>

<script>
    import TopBar from '../components/TopBar'
    import constants from '../constants'
    import AudioPage from './AudioPage'
    import TextPage from './TextPage'
    import GalleryPage from './GalleryPage'
    import ImagePage from './ImagePage'
    import SubmenuPage from './SubmenuPage'

    export default {
        name: 'menu',
        components: {
            TopBar,
        },
        data: function () {
            return {
                menuItems: this.$t("message.menuItems"),
                title: this.$t("message.title"),
                titleMap: this.$t("message.titleMap"),
                /*map: require('../assets/img/art/Plano1.png'),*/
                icon_map: require('../assets/img/UI/gota_mapa.png'),

            }
        },
        computed: {
            visitType: {
                get() {
                    return this.$store.state.visit.type
                },
            },
            fullMenuItems() {

                this.$store.state.visit.type=constants.VISIT_TYPE_LISTEN

                this.menuItems.forEach((elementMenuItem) => {
                    /*let images = Images.images.find((elementImage) => {
                        if (elementImage.id === elementMenuItem.idImages) {
                            return elementImage
                        }
                    });*/
                    /*if(images.imagesAudio){
                        elementMenuItem.imagesAudio = images.imagesAudio;
                    }*/
                    /*elementMenuItem.img = images.img;
                    elementMenuItem.imageMenu = images.imageMenu;*/

                    //constants.URL_AUDIO

                    var idioma="";
                    let lang=this.$i18n.locale;
                    if (lang == "Castellano") {
                        idioma = "ESP";
                    } else if (lang == "English") {
                        idioma = "ENG";
                    } else if (lang == "Français") {
                        idioma = "FRA";
                    } else if (lang == "Català") {
                      idioma = "CAT";
                    } else if (lang == "Deutsch") {
                        idioma = "DEU";
                    } else if (lang == "Português") {
                        idioma = "POR";
                    } else if (lang == "한국어") {
                        idioma = "KOR";
                    } else if (lang == "官話") {
                        idioma = "CHI";
                    }

                    elementMenuItem.path_audio =  "/audios/"+idioma+"/"+ elementMenuItem.audio;

                    /*if(elementMenuItem.isCredits) {
                        let imageCredit = Images.images.find((elementImage) => {
                            if (elementImage.id === elementMenuItem.idCreditImage) {
                                return elementImage
                            }
                        });
                        elementMenuItem.imgCredit = imageCredit.img;
                    }*/
                  if(elementMenuItem.isCredits) {
                    elementMenuItem.imgCredit = elementMenuItem.img;
                  }


                    console.log(elementMenuItem.path_audio);
                });
                return this.menuItems;
            }
        },
        mounted() {



//            let titles = document.getElementsByClassName("title");
////            console.log(titles);
////            for (let title of titles) {
////                console.log(title.height);
////            }
//            Array.from(document.getElementsByClassName("title")).forEach(function(item) {
////                console.log(item);
//                if (item instanceof HTMLElement) {
//                    console.log(item.height);
//                    console.log(item.style.height);
////                    item.style.height = "10px";
//                }
//            });
        },
        methods: {
            push(item) {

              console.log("push item");
              console.log(item.menuSubItems.length);
              console.log("push item");
                if(item.menuSubItems.length>0){
                  this.$emit('push', {
                    extends: SubmenuPage,
                    onsNavigatorProps: {
                      title:item.title,
                      map:item.map,
                      menuItems: item.menuSubItems
                    }
                  });
                }

                else if (item.isGallery) {
                    this.$emit('push', {
                        extends: GalleryPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                } else if (item.isCredits) {
                    this.$emit('push', {
                        extends: TextPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                }
                else if (this.$store.state.visit.type === constants.VISIT_TYPE_READ) {

                    this.$emit('push', {
                        extends: TextPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                } else if (this.$store.state.visit.type === constants.VISIT_TYPE_LISTEN) {
                    if (item.imagesAudio) {
                        item.img = item.imagesAudio[0].img;
                        console.log('HASSS IMAGES AUDIOOOS¡¡¡¡');
                        console.log(item.imagesAudio);
                    }
                    this.$emit('push', {
                        extends: AudioPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                }

//                this.$i18n.locale = lang;
//                this.$store.commit('langs/toggle', lang)
//                this.$emit('push', {
//                    extends: MenuPage,
//
//                });
            },
            pushMap(){
                console.log("push map "+this.map);
                this.$emit('push', {
                    extends: ImagePage,
                    onsNavigatorProps: {
                        image: this.map,
                        title: this.titleMap

                    }
                });
            }
        },
    }
</script>
<style lang="css" src="../assets/css/styles.css"/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .padding0 {
        padding: 0;
    }

    #menuPage .list-item__center {
        padding: 0;

    }

    .content {
        margin: 0px 0px -6px 0px;
        width: 100%;
    }

    .title {
      position: absolute;
      bottom: 43%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      color: white;
      text-align: center;
      font-size: 4vw !important;
    }

    .author {
        position: absolute;
        bottom: 2%;
        left: 17%;
        /*font-size: 18pt;*/
    }

    /*.menulist{
        margin-top: 27% !important;
    }*/

    .zindex9 {
        z-index: 99;
    }
    .zindex1 {
        z-index: 1;
    }
    .text-center {
        text-align: center;
    }

    .toolbar__title {
        font-size: 3.75vw;
    }

    .toolbar__left {
        width: 21%;
    }

    .icon-right img {
        height: 41px;
        padding-right: 8px;
    }


    .toolbar--material__left {
        width: 15%;
    }

    .toolbar {
        height: auto;
        min-height:56px;
        padding-top: 7% !important;
    }

    @media (min-width: 800px) {
        .toolbar {
            padding-top: 30px !important;
        }

      .title {
        bottom: 45%;
      }

    }


</style>



// WEBPACK FOOTER //
// src/pages/MenuPage.vue